<main id="main" class="main__offset-header">
  <section>
    <div class="container">
      <h1>Accessibility</h1>
      <div class="row">
        <div class="col-12 col-sm-8">
          <p>
            EuroGeographics is committed to ensuring the accessibility of the Open Maps For Europe
            website for all users.
          </p>
          <p>This includes:</p>
          <ul>
            <li>
              Using semantic page markup so that browser plugins or assistive technologies, such as
              screen readers, can list the headings and subheadings, allowing users to navigate to
              the relevant sections.
            </li>
            <li>
              Including the correct markup for interactive elements, such as links, buttons and form
              fields, so that they can be accessed using keyboard navigation and assistive
              technologies.
            </li>
            <li>
              Ensuring users can clearly see interactive elements in focus, such as links, buttons
              and form fields.
            </li>
            <li>Enabling users to skip navigation links and jump directly to main page content.</li>
            <li>
              Ensuring that text and icons have appropriate contrast ratio to support visually
              impaired users.
            </li>
            <li>Including screen-reader accessible text for images and icons.</li>
            <li>
              Ensuring the website is responsive and viewable on different devices and screen sizes.
            </li>
          </ul>
          <h2>Report problems</h2>
          <p>
            If you find any accessibility problems or feel that we could better meet specific
            accessibility requirements, please
            <a routerLink="/contact">contact us</a>.
          </p>
        </div>
      </div>
    </div>
  </section>
</main>
<app-footer [showBackToTop]="true" target="main"></app-footer>
